module.exports = __webpack_public_path__ + "@/assets/img/banner-mp.f2c22000.jpg";